import server from "@/plugins/http.js";
// 订单记录
export function orderlist(data) {
    return server({
        url: '/api/app/order/list',
        method: 'post',
        data: data,
    })
}
// 选择云手机列表
export function activationlist(query) {
    return server({
        url: '/api/app/activation/list?skuIds=' + query,
        method: 'get',
        query: query
    })
}
// 使用新增激活码
export function activationuseadd(data) {
    return server({
        url: '/api/app/activation/use/add',
        method: 'post',
        data: data,
    })
}
// 激活码验证SKU
export function activationVerifySku(data) {
    return server({
        url: '/api/app/activation/activationVerifySku',
        method: 'post',
        data: data,
    })
}
// 激活新增时码验证SKU
export function addActivationVerifySku(data) {
    return server({
        url: '/api/app/activation/add/activationVerifySku',
        method: 'post',
        data: data,
    })
}
// 使用续时激活码
export function activationuseextend(data) {
    return server({
        url: '/api/app/activation/use/extend',
        method: 'post',
        data: data,
    })
}
// 获取H5推广套餐
export function commissionpackagelist(params) {
    return server({
        url: '/api/app/vip/h5/commission/package/list',
        method: 'get',
        params: params,
    })
}
// 获取openid
export function getopenId(data) {
    return server({
        url: '/api/app/user/get/openId',
        method: 'post',
        data: data,
    })
}
// h5获取当日注册人数
export function userCountlist(params) {
    return server({
        url: '/api/admin/index/h5/userCount',
        method: 'get',
        params: params,
    })
}
// 创建订单
export function ordercreate(data) {
    return server({
        url: '/api/app/order/create',
        method: 'post',
        data: data,
    })
}
// 获取支付宝完整支付链接
export function payLinke(params) {
    return server({
        url: '/api/app/ali/pay/linke',
        method: 'get',
        params: params,
    })
}
// 获取VIP下的版本和套餐V2
export function packageversionListV2(data) {
    return server({
        url: '/api/app/vip/v2/package/versionList',
        method: 'post',
        data: data,
    })
}
// 查询订单状态
export function infoRderNo(params) {
    return server({
        url: `/api/app/order/info/${params}`,
        method: 'get',
    })
}